import { Avatar, AvatarProps } from '@mui/material';

import { getInitials } from '@altirllc/shared/utils/stringUtils';

import { combineStyles } from '@/utils/styleUtils';

import { colors } from '@/themesConfig/colors';

type TUserAvatarProps = AvatarProps & {
  name: string;
  size?: number;
};

export const UserAvatar = ({ name, size = 40, sx, ...props }: TUserAvatarProps) => {
  const initials = getInitials(name);

  return (
    <Avatar
      sx={combineStyles(
        {
          width: size,
          height: size,
          fontSize: size / 2.5,
          fontWeight: 500,
          backgroundColor: colors.bgBlue,
          color: colors.mediumGrey2,
        },
        sx,
      )}
      {...props}
    >
      {initials}
    </Avatar>
  );
};
